import ObrigacoesService from '../Obrigacoes/Obrigacoes.service';

type LogLoginGovernancaCallback = (idEmpresa: number | string, obrigacoesService: ObrigacoesService) => void;

class LogLoginGovernancaService {
	private logLoginGovernancaCallback: LogLoginGovernancaCallback | null = null;

	setLoginGovernancaCallback(callback: LogLoginGovernancaCallback | null) {
		this.logLoginGovernancaCallback = callback;
	}

	loginLogUsuario(idEmpresa: number | string, obrigacoesService: ObrigacoesService) {
		if (this.logLoginGovernancaCallback) {
			this.logLoginGovernancaCallback(idEmpresa, obrigacoesService);
		}
	}

	verificarAuthSession = () => {
		return sessionStorage.getItem('governancaLoggedIn') === 'true';
	};

	autenticarAuthSession = () => {
		sessionStorage.setItem('governancaLoggedIn', 'true');
	};

	limparAuthSession = () => {
		sessionStorage.removeItem('governancaLoggedIn');
	};
}

export const logLoginGovernancaService = new LogLoginGovernancaService();
